// src/components/Paiements.js
import React, { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy, doc, getDoc } from "firebase/firestore";
import { db } from "../services/firebase";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function Paiements() {
  const [paiements, setPaiements] = useState([]);
  const [enriched, setEnriched] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [msg, setMsg] = useState("");

  useEffect(() => { charger(); }, []);

  async function charger() {
    const snap = await getDocs(query(collection(db, "paiements"), orderBy("createdAt", "desc")));
    const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setPaiements(list);

    // Enrichir avec les noms org et tombola
    const enrichedList = await Promise.all(list.map(async (p) => {
      let orgNom = p.orgId?.slice(0, 12) + "…";
      let tombolaNom = p.tombolaId?.slice(0, 12) + "…";
      try {
        const orgSnap = await getDoc(doc(db, "organisations", p.orgId));
        if (orgSnap.exists()) orgNom = orgSnap.data().nom || orgNom;
        const tombolaSnap = await getDoc(doc(db, "organisations", p.orgId, "tombolas", p.tombolaId));
        if (tombolaSnap.exists()) tombolaNom = tombolaSnap.data().nom || tombolaNom;
      } catch { /* keep default */ }
      return { ...p, orgNom, tombolaNom };
    }));
    setEnriched(enrichedList);
    setLoading(false);
  }

  async function renvoyerEmail(p) {
    try {
      await fetch("https://europe-west1-tombolive-prod.cloudfunctions.net/envoyerEmailPaiement", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: p.userId,
          tombolaName: p.tombolaNom,
          orgNom: p.orgNom,
          montant: p.amount,
        }),
      });
      setMsg("✅ Email renvoyé !");
      setTimeout(() => setMsg(""), 3000);
    } catch {
      setMsg("❌ Erreur envoi email");
      setTimeout(() => setMsg(""), 3000);
    }
  }

  function genererFacturePDF(p, index) {
    const doc2 = new jsPDF();
    const W = doc2.internal.pageSize.getWidth();
    const numFacture = `TL-${new Date(p.createdAt?.toDate?.()).getFullYear()}-${String(index + 1).padStart(4, "0")}`;

    // Header
    doc2.setFillColor(26, 58, 143);
    doc2.rect(0, 0, W, 35, "F");
    doc2.setTextColor(255, 255, 255);
    doc2.setFontSize(20);
    doc2.setFont("helvetica", "bold");
    doc2.text("TomboLive", 14, 15);
    doc2.setFontSize(10);
    doc2.setFont("helvetica", "normal");
    doc2.text("tombo.live · contact@tombo.live", 14, 23);
    doc2.text(`FACTURE ${numFacture}`, W - 14, 20, { align: "right" });

    // Infos
    doc2.setTextColor(50, 50, 50);
    doc2.setFontSize(11);
    doc2.setFont("helvetica", "bold");
    doc2.text("Facturé à :", 14, 50);
    doc2.setFont("helvetica", "normal");
    doc2.text(p.orgNom, 14, 58);
    doc2.text(`Date : ${p.createdAt?.toDate?.().toLocaleDateString("fr-FR") || "—"}`, W - 14, 58, { align: "right" });

    autoTable(doc2, {
      startY: 70,
      head: [["Description", "Quantité", "Prix unitaire", "Total"]],
      body: [
        [`Plan Pro — Tombola "${p.tombolaNom}"`, "1", `${p.amount}€`, `${p.amount}€`],
      ],
      foot: [["", "", "Total TTC", `${p.amount}€`]],
      headStyles: { fillColor: [26, 58, 143], textColor: 255, fontStyle: "bold" },
      footStyles: { fillColor: [238, 240, 255], textColor: [26, 58, 143], fontStyle: "bold" },
    });

    doc2.setFontSize(9);
    doc2.setTextColor(150);
    doc2.text("TomboLive — Auto-entrepreneur · TVA non applicable, art. 293 B du CGI", 14, 200);

    doc2.save(`Facture_${numFacture}_${p.orgNom.replace(/\s/g, "_")}.pdf`);
  }

  function exporterExcel() {
    const data = filtered.map((p) => ({
      "Date": p.createdAt?.toDate?.().toLocaleDateString("fr-FR") || "—",
      "Organisation": p.orgNom,
      "Tombola": p.tombolaNom,
      "Montant (€)": p.amount,
      "Statut": p.status,
      "Session Stripe": p.sessionId,
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    ws["!cols"] = [{ wch: 12 }, { wch: 30 }, { wch: 30 }, { wch: 12 }, { wch: 10 }, { wch: 40 }];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Paiements");
    XLSX.writeFile(wb, `TomboLive_Paiements_${new Date().toLocaleDateString("fr-FR").replace(/\//g, "-")}.xlsx`);
  }

  // Filtrage
  const filtered = enriched.filter((p) => {
    const matchSearch = p.orgNom?.toLowerCase().includes(search.toLowerCase()) ||
      p.tombolaNom?.toLowerCase().includes(search.toLowerCase()) ||
      p.sessionId?.toLowerCase().includes(search.toLowerCase()) ||
      p.userId?.toLowerCase().includes(search.toLowerCase());

    let matchDate = true;
    if (p.createdAt?.toDate) {
      const d = p.createdAt.toDate();
      if (dateDebut) matchDate = matchDate && d >= new Date(dateDebut);
      if (dateFin) matchDate = matchDate && d <= new Date(dateFin + "T23:59:59");
    }
    return matchSearch && matchDate;
  });

  const totalRevenu = filtered.reduce((acc, p) => acc + (p.amount || 0), 0);

  if (loading) return <div style={s.loading}>⏳ Chargement…</div>;

  return (
    <div>
      {/* KPI */}
      <div style={s.kpiRow}>
        <div style={s.kpi}>
          <div style={s.kpiVal}>{filtered.length}</div>
          <div style={s.kpiLab}>Paiements</div>
        </div>
        <div style={s.kpi}>
          <div style={{ ...s.kpiVal, color: "#2e7d32" }}>{totalRevenu}€</div>
          <div style={s.kpiLab}>Revenu filtré</div>
        </div>
        <div style={s.kpi}>
          <div style={{ ...s.kpiVal, color: "#ff8f00" }}>
            {filtered.length > 0 ? (totalRevenu / filtered.length).toFixed(0) : 0}€
          </div>
          <div style={s.kpiLab}>Panier moyen</div>
        </div>
      </div>

      {msg && <div style={s.msg}>{msg}</div>}

      {/* Filtres */}
      <div style={s.filtres}>
        <input type="text" placeholder="🔍 Rechercher par org, tombola, email…"
          value={search} onChange={(e) => setSearch(e.target.value)} style={s.search} />
        <input type="date" value={dateDebut} onChange={(e) => setDateDebut(e.target.value)} style={s.dateInput} />
        <span style={{ color: "#aaa", alignSelf: "center" }}>→</span>
        <input type="date" value={dateFin} onChange={(e) => setDateFin(e.target.value)} style={s.dateInput} />
        <button onClick={() => { setDateDebut(""); setDateFin(""); setSearch(""); }} style={s.btnReset}>
          ✕ Réinitialiser
        </button>
        <button onClick={exporterExcel} style={s.btnExport}>
          📊 Export Excel
        </button>
      </div>

      {filtered.length === 0 ? (
        <div style={s.empty}>Aucun paiement trouvé.</div>
      ) : (
        <div style={s.table}>
          <div style={s.thead}>
            <div style={s.th}>Date</div>
            <div style={s.th}>Organisation</div>
            <div style={s.th}>Tombola</div>
            <div style={{ ...s.th, textAlign: "center" }}>Montant</div>
            <div style={{ ...s.th, textAlign: "center" }}>Statut</div>
            <div style={{ ...s.th, textAlign: "center" }}>Actions</div>
          </div>
          {filtered.map((p, i) => (
            <div key={p.id} style={s.row}>
              <div style={s.td}>
                {p.createdAt?.toDate?.().toLocaleDateString("fr-FR") || "—"}
              </div>
              <div style={{ ...s.td, fontWeight: "600" }}>{p.orgNom}</div>
              <div style={s.td}>{p.tombolaNom}</div>
              <div style={{ ...s.td, textAlign: "center", fontWeight: "700", color: "#2e7d32" }}>
                {p.amount}€
              </div>
              <div style={{ ...s.td, textAlign: "center" }}>
                <span style={p.status === "paid" ? s.badgePaid : s.badgePending}>
                  {p.status === "paid" ? "✅ Payé" : p.status}
                </span>
              </div>
              <div style={{ ...s.td, textAlign: "center", display: "flex", gap: "6px", justifyContent: "center" }}>
                <button onClick={() => genererFacturePDF(p, i)} style={s.btnAction} title="Télécharger facture">
                  🧾
                </button>
                <button onClick={() => renvoyerEmail(p)} style={s.btnAction} title="Renvoyer email">
                  📧
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  loading: { textAlign: "center", padding: "2rem", color: "#667eea" },
  kpiRow: { display: "flex", gap: "16px", marginBottom: "1.5rem", flexWrap: "wrap" },
  kpi: { flex: 1, minWidth: "140px", background: "#fff", borderRadius: "12px", padding: "1.25rem", textAlign: "center", border: "1px solid #eee" },
  kpiVal: { fontSize: "1.75rem", fontWeight: "900", color: "#1a3a8f" },
  kpiLab: { fontSize: "0.78rem", color: "#888", textTransform: "uppercase", fontWeight: "600", marginTop: "4px" },
  msg: { background: "#e8f5e9", color: "#2e7d32", borderRadius: "8px", padding: "0.75rem 1rem", marginBottom: "1rem", fontSize: "0.88rem" },
  filtres: { display: "flex", gap: "10px", marginBottom: "1rem", flexWrap: "wrap", alignItems: "center" },
  search: { flex: 2, minWidth: "200px", padding: "0.65rem 1rem", border: "1.5px solid #e0e0e0", borderRadius: "8px", fontSize: "0.9rem", outline: "none" },
  dateInput: { padding: "0.65rem 0.75rem", border: "1.5px solid #e0e0e0", borderRadius: "8px", fontSize: "0.9rem", outline: "none" },
  btnReset: { padding: "0.65rem 1rem", background: "#f5f5f5", border: "1px solid #ddd", borderRadius: "8px", cursor: "pointer", fontSize: "0.85rem", color: "#666" },
  btnExport: { padding: "0.65rem 1rem", background: "linear-gradient(135deg,#2e7d32,#43a047)", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "0.85rem", fontWeight: "700" },
  empty: { textAlign: "center", padding: "3rem", color: "#aaa" },
  table: { background: "#fff", borderRadius: "12px", overflow: "hidden", border: "1px solid #eee" },
  thead: { display: "grid", gridTemplateColumns: "100px 1fr 1fr 80px 90px 90px", background: "#1a3a8f", padding: "0.75rem 1rem" },
  th: { color: "#fff", fontSize: "0.75rem", fontWeight: "700", textTransform: "uppercase" },
  row: { display: "grid", gridTemplateColumns: "100px 1fr 1fr 80px 90px 90px", padding: "0.875rem 1rem", borderBottom: "1px solid #f5f5f5", alignItems: "center" },
  td: { fontSize: "0.88rem", color: "#333" },
  badgePaid: { background: "#e8f5e9", color: "#2e7d32", borderRadius: "6px", padding: "3px 8px", fontSize: "0.75rem", fontWeight: "700" },
  badgePending: { background: "#fff8e1", color: "#ff8f00", borderRadius: "6px", padding: "3px 8px", fontSize: "0.75rem", fontWeight: "700" },
  btnAction: { padding: "4px 8px", background: "#f0f0f0", border: "1px solid #ddd", borderRadius: "6px", cursor: "pointer", fontSize: "1rem" },
};
